import styled from 'styled-components';
import { useController, useFormContext } from 'react-hook-form';

import { FormField } from 'ui/formField';
import { TileRadio } from 'ui/radio/TileRadio';
import { colors } from 'ui/theme';
import { ConfirmNew24, Exit24 } from 'ui/icons';
import { ImportType } from 'modules/domains/adminApp';

import { TileRadioGrid } from './TileRadioGrid';
import { FormFieldKey } from './types';
import { createPatternValidatorForEnum } from './utils/createPatternValidatorForEnum';
import {
  DISABLE_FEATURE_OPTION,
  ENABLE_FEATURE_OPTION,
  IMPORT_TYPE_INPUT_LABEL,
  VALIDATION_MSG_IMPORT_TYPE_REQUIRED,
} from './constants';

const GreenTileRadio = styled(TileRadio)`
  color: ${colors.textSuccess};
`;

const RedTileRadio = styled(TileRadio)`
  color: ${colors.textDestructive};
`;

export const ImportTypeInput = () => {
  const { control } = useFormContext();
  const {
    field: { name, onChange, value: selection },
    fieldState: {
      error: { message: errorMessage } = {},
    },
  } = useController({
    name: FormFieldKey.ImportType,
    control,
    rules: {
      required: VALIDATION_MSG_IMPORT_TYPE_REQUIRED,
      pattern: createPatternValidatorForEnum(ImportType),
    },
  });

  const createProps = (value: ImportType) => ({
    name,
    value,
    onClick: () => onChange({ target: { value } }),
    isChecked: selection === value,
  });

  return (
    <FormField
      labelText={IMPORT_TYPE_INPUT_LABEL}
      hasError={!!errorMessage}
      errorText={errorMessage}
      isRequired
    >
      <TileRadioGrid>
        <GreenTileRadio {...createProps(ImportType.EnableFeature)}>
          <ConfirmNew24 isColorInherited /> {ENABLE_FEATURE_OPTION}
        </GreenTileRadio>
        <RedTileRadio {...createProps(ImportType.DisableFeature)}>
          <Exit24 isColorInherited /> {DISABLE_FEATURE_OPTION}
        </RedTileRadio>
      </TileRadioGrid>
    </FormField>
  );
};
